export const MEDIA_TYPE = {
	VIDEO: "videoAudio",
	AUDIO: "audio",
	SUBTITLE: "subtitle",
	GIF: "gif",
	PODCAST: "podcast",
	IMAGE: "image",
};

/** Wire-format media kinds used by exports, social connections, and the library. */
export type MediaType = "videoAudio" | "audio" | "subtitle" | "gif" | "podcast" | "image";

const MEDIA_FORMAT = {
	MP4: "",
	MP3: "MP3",
	GIF: "GIF",
	VTT: "subtitles:en-US.vtt",
};

export const MEDIA = {
	[MEDIA_TYPE.VIDEO]: MEDIA_FORMAT.MP4,
	[MEDIA_TYPE.AUDIO]: MEDIA_FORMAT.MP3,
	[MEDIA_TYPE.PODCAST]: MEDIA_FORMAT.MP3,
	[MEDIA_TYPE.SUBTITLE]: MEDIA_FORMAT.VTT,
	[MEDIA_TYPE.GIF]: MEDIA_FORMAT.GIF,
};

export const UPLOAD_TYPE = {
	RECORD: "record",
	COVER_PHOTO: "coverPhoto",
};

export const DOC_EXTENSIONS = [
	".doc",
	".docx",
	".xls",
	".xlsx",
	".ppt",
	".pptx",
	".csv",
	".txt",
	".pdf",
];

export const EDITOR_ALLOWED_DOC_EXTENSIONS = [".pdf", ".ppt", ".pptx"];
